import { render } from "./SelecionarNaturezaOperacao.vue?vue&type=template&id=caaca37c&ts=true"
import script from "./SelecionarNaturezaOperacao.vue?vue&type=script&lang=ts"
export * from "./SelecionarNaturezaOperacao.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__